export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              We Buy Rental Property with Tenants in Place
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Selling tenant occupied property doesn't have to be complicated. At T-Rex Real Estate, we specialize in purchasing rental properties with tenants still in place throughout El Paso, Texas. Whether you own a single-family rental home, duplex, triplex, or multi-unit apartment building, we make the process fast, simple, and secure.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Unlike traditional buyers who shy away from tenant occupied real estate, we embrace it. We understand the unique challenges landlords face when trying to sell with tenants, and we've developed a streamlined process that protects everyone involved—you, your tenants, and us. We also purchase <a href="/land-buyers" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">vacant land</a> and <a href="/inherited-homes" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">inherited properties</a> throughout El Paso.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              With over <strong>200 rental properties purchased</strong> and more than <strong>$120 million in total transactions</strong>, we have the experience, resources, and proven track record to close quickly and professionally. Every transaction is handled through a reputable title company, ensuring complete legal protection and peace of mind. As <a href="/elpaso-tx" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso's trusted cash buyers</a>, we're committed to helping landlords exit smoothly. For market insights and trends, check out our <a href="/local-news-el-paso-texas" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso real estate news</a>.
            </p>
            
            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg">
              <div className="flex items-start space-x-4">
                <i className="ri-information-fill text-teal-600 text-3xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2 text-lg">Why Landlords Choose Us</h3>
                  <p className="text-gray-700">
                    We buy rental property in any condition, with any tenant situation. Whether your tenants are paying on time or you're dealing with difficult occupants, we can help. We handle all the complexities so you can move on to your next investment or life chapter.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/742a639e853322764e5bc383e0bbaaba.jpg"
              alt="We Buy Rental Property El Paso"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-lg shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-2">7-14 Days</div>
              <div className="text-teal-100">Average closing time for tenant occupied properties</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}